export const storageKeys = {
    USER: 'user-key'
}
